import { render } from "./StandardSelection.vue?vue&type=template&id=6d4a0366&ts=true"
import script from "./StandardSelection.vue?vue&type=script&lang=ts"
export * from "./StandardSelection.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Waddecar Media\\Development\\Forms\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__